<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="icon-svg icon-frame"
  >
    <g
      stroke="none"
      stroke-width="1"
      fill-rule="evenodd"
    >
      <path
        d="M3.3875,16.7186 C7.8835,17.3406 12.3625,15.8576 15.7905,12.5956 C15.1005,10.8646 14.7035,9.8966 14.7025,9.8946 C14.6325,9.7226 14.6465,9.5236 14.7395,9.3666 C14.8325,9.2086 14.9925,9.1126 15.1645,9.1126 L18.6935,9.1126 C19.7675,7.3416 20.5245,5.3296 20.9025,3.2456 C19.9645,3.1156 19.0165,3.0766 18.0775,3.1316 C13.8365,3.3746 9.9375,5.4106 7.0955,8.8636 C5.2335,11.1276 3.9725,13.8226 3.3875,16.7186 M2.5295,21.9996 C2.2615,21.9996 2.0375,21.7706 2.0235,21.4746 C1.7875,16.5376 3.3215,11.7956 6.3435,8.1216 C9.3655,4.4486 13.5145,2.2836 18.0235,2.0246 C19.2115,1.9576 20.4045,2.0266 21.5735,2.2316 C21.7065,2.2546 21.8255,2.3346 21.9045,2.4536 C21.9835,2.5736 22.0155,2.7216 21.9935,2.8676 C21.6185,5.4046 20.7145,7.8646 19.3785,9.9826 C19.2845,10.1326 19.1285,10.2216 18.9625,10.2216 L15.9435,10.2216 C16.1565,10.7456 16.4695,11.5236 16.8655,12.5216 C16.9525,12.7396 16.9035,12.9936 16.7425,13.1526 C13.0435,16.8316 8.1315,18.5116 3.1995,17.8096 C3.0335,18.9896 2.9765,20.1966 3.0345,21.4166 C3.0495,21.7226 2.8345,21.9836 2.5555,21.9996 C2.5465,21.9996 2.5375,21.9996 2.5295,21.9996"
      />
    </g>
  </svg>
</template>